import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { BreakEffects } from 'app/state/break/break.effects';
import { breakStateFeature } from 'app/state/break/break.reducer';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(breakStateFeature), EffectsModule.forFeature(BreakEffects)],
})
export class BreakStateModule {}
